import { differenceInDays, addDays, isWeekend } from 'date-fns';

export const calculateBusinessDays = (startDate, endDate) => {
  let count = 0;
  let currentDate = new Date(startDate);

  while (currentDate <= endDate) {
    if (!isWeekend(currentDate)) {
      count++;
    }
    currentDate = addDays(currentDate, 1);
  }

  return count;
};

export const isWorkday = (date) => {
  return !isWeekend(date);
};

export const getNextWorkday = (date) => {
  let nextDate = addDays(date, 1);
  while (isWeekend(nextDate)) {
    nextDate = addDays(nextDate, 1);
  }
  return nextDate;
};

export const getPreviousWorkday = (date) => {
  let prevDate = addDays(date, -1);
  while (isWeekend(prevDate)) {
    prevDate = addDays(prevDate, -1);
  }
  return prevDate;
};
